import { useNuxtApp } from "#app"
import { SHOW_ERROR } from "/assets/events/errors.js"

export default defineNuxtPlugin((nuxtApp) => {
	const { $authApiService, $eventBus, $messages } = useNuxtApp()
	const authStore = useAuthStore()
	const settingsStore = useSettingsStore()
	const credentialTypeStore = useCredentialTypeStore()
	const userStore = useUserStore()
	const orderStore = useOrderStore()
	const credentialStore = useCredentialStore()
	const eventStore = useEventStore()
	const notificationStore = useNotificationStore()
	const toastStore = useToastStore()

	nuxtApp.provide("authService", {
		$login: async (email, password) => {
			const requestBody = {
				email: email,
				password: password,
			}

			const successHandler = (res) => {
				const data = res.data

				authStore.$reset()
				settingsStore.$reset()
				credentialTypeStore.clear()
				userStore.clear()
				orderStore.clear()
				credentialStore.clear()
				eventStore.clear()
				notificationStore.clear()

				authStore.setIsAuthenticated(true)
				authStore.setToken(data.token)

				settingsStore.setCurrentEventId(data.settings.current_event_id)
				credentialTypeStore.storeCredentialTypesFromJson(data.settings.credential_types)

				notificationStore.storeNotificationsFromJson(data.notifications)
				userStore.storeUserFromJson(data.user)
				orderStore.storeOrdersFromJson(data.orders)
				credentialStore.storeCredentialsFromJson(data.credentials)
				eventStore.storeEventsFromJson(data.events)

				navigateTo("/")
			}

			await $authApiService.$login(requestBody, successHandler)
		},

		$logout: async () => {
			const successHandler = () => {
				authStore.$reset()
				navigateTo("/login")
			}

			await $authApiService.$logout({}, successHandler)
		},

		$forgotPassword: async (email) => {
			const requestBody = {
				email: email,
			}

			const successHandler = () => {
				$eventBus.$emit(SHOW_ERROR, {
					titleText: $messages.$t("forgotPasswordSuccessTitle"),
					bodyText: $messages.$t("forgotPasswordSuccessBody"),
				})
			}

			await $authApiService.$forgotPassword(requestBody, successHandler)
		},

		$resetPassword: async (password, token) => {
			const requestBody = {
				password: password,
				reset_token: token,
			}

			const successHandler = () => {
				toastStore.setSuccess($messages.$t("resetPasswordSuccessMsg"))
				navigateTo("/login")
			}

			await $authApiService.$resetPassword(requestBody, successHandler)
		},
	})
})
